import { z } from 'zod';
import { getConditionalTransitionDtoSchema } from '../getConditionalTransitionDtoSchema';

export const conditionalTransitionsControllerGetAllBySourceCardQueryParamsSchema =
  z.object({ sourceCardId: z.string().uuid() });

export const conditionalTransitionsControllerGetAllBySourceCard200Schema =
  z.array(z.lazy(() => getConditionalTransitionDtoSchema));

export const conditionalTransitionsControllerGetAllBySourceCard400Schema =
  z.object({
    statusCode: z.enum(['400']),
    message: z.string(),
    type: z.enum(['InvalidData']),
    details: z.object({
      location: z.enum(['path', 'query', 'body']),
      explanation: z.object({
        issues: z.array(
          z
            .object({
              code: z.enum([
                'invalid_type',
                'invalid_literal',
                'custom',
                'invalid_union',
                'invalid_union_discriminator',
                'invalid_enum_value',
                'unrecognized_keys',
                'invalid_arguments',
                'invalid_return_type',
                'invalid_date',
                'invalid_string',
                'too_small',
                'too_big',
                'invalid_intersection_types',
                'not_multiple_of',
                'not_finite',
              ]),
              path: z.array(z.union([z.string(), z.number()])),
              message: z.string(),
            })
            .catchall(z.unknown()),
        ),
      }),
    }),
  });

export const conditionalTransitionsControllerGetAllBySourceCard401Schema =
  z.object({
    statusCode: z.enum(['401']),
    message: z.string(),
    type: z.enum(['Authentication']),
    details: z.object({
      reason: z.enum(['InvalidRequest', 'InvalidToken', 'Unauthorized']),
    }),
  });

export const conditionalTransitionsControllerGetAllBySourceCard403Schema =
  z.object({
    statusCode: z.enum(['403']),
    message: z.string(),
    type: z.enum(['Authorization']),
    details: z.object({ reason: z.enum(['InsufficientScope']) }),
  });

export const conditionalTransitionsControllerGetAllBySourceCardQueryResponseSchema =
  z.array(z.lazy(() => getConditionalTransitionDtoSchema));
